import type { FaireProductEntity } from "../../entity_types/product";

export const p_g9rzfy3euc: FaireProductEntity = {
  token: "p_g9rzfy3euc",
  type: "product",
  name: "LM-TP1000 - PRINT BABY DOLL TOP SS-  LEOPARD",
  brandToken: "b_h6l667zq",
  brandName: "Girlie Girl Originals",
  imageUrl: "https://cdn.faire.com/fastly/af81875b2478236fca045edeb17eaf63c79a39617417ab069a5d50cb9c2a29f5.jpeg",
  galleryImageUrls: [],
  priceDollars: 15.5,
  description: "This playful women's T-shirt from Girlie Girl Originals features a leopard print baby doll silhouette that combines a flattering shape with an eye-catching pattern. Designed for casual wear, it offers charm and versatile styling options to brighten your wardrobe with a touch of spirited, Southern-inspired flair.",
  tags: [],
  msrpDollars: 31,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:01:53.034Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
